export const TASK_CANCELLED_ERROR_MESSAGE = 'Task cancelled';

const TASK_INSUFFICIENT_BALANCE_ERROR_MESSAGES = new Set(['coin_nogood', 'insufficient_credits']);

/** 判断执行任务失败是否来自用户主动取消，供调用方跳过失败提示。 */
export function isTaskCancelledError(error: unknown): boolean {
  return error instanceof Error && error.message === TASK_CANCELLED_ERROR_MESSAGE;
}

/** 判断任务响应是否为余额不足，兼容前置校验错误和 nodeexecute 接口的 code / 文案返回。 */
export function isTaskInsufficientBalanceError(error: unknown): boolean {
  if (error instanceof Error && TASK_INSUFFICIENT_BALANCE_ERROR_MESSAGES.has(error.message)) {
    return true;
  }
  if (!error || typeof error !== 'object') {
    return false;
  }

  const response = error as Record<string, unknown>;
  const code = response.error_code ?? response.code ?? response.fail_code;
  const messages = [
    error instanceof Error ? error.message : undefined,
    response.error_msg,
    response.error_message,
    response.message,
    response.msg,
  ].filter((message): message is string => typeof message === 'string');
  const combinedText = messages.join(' ');
  return code === 'INSUFFICIENT_BALANCE'
    || messages.some((message) => TASK_INSUFFICIENT_BALANCE_ERROR_MESSAGES.has(message))
    || combinedText.includes('积分不足')
    || combinedText.includes('余额不足');
}
